import React from 'react';
import { Helmet } from 'react-helmet';

const About = () => {
  return (
    <div className="about">
      <Helmet>
        <title>О нас - ReserveCar</title>
        <meta name="description" content="Узнайте больше о нашей компании по аренде автомобилей Reservecar." />
      </Helmet>
      <h1>О нас</h1>
      <p>
        Мы — компания, предлагающая услуги аренды автомобилей от беюджетных до автомобилей премиум-класса. Наша цель —
          сделать вашу поездку максимально комфортной и безопасной.
      </p>
      <p>
        Мы работаем с 2020 года и гордимся тем, что наши клиенты всегда остаются довольны нашим сервисом.
      </p>
      <h2>Наши преимущества:</h2>
      <ul>
        <li>Минимальный залог и максимально быстрое оформление</li>
        <li>Bсe aвтoмобили находятcя в отличнoм cостoянии</li>
        <li>Удобный вoзврат и подача aвтoмoбиля</li>
        <li>Автомобили подаются чистыми, с полным баком топлива</li>
        <li>При необходимости предоставляем детский бустер или кресло БЕСПЛАТНО.</li>
      </ul>
      <h4 className="ip_name_about">ИП Михайлов Ю.В. ИНН 391704935103 ОГРНИП 316392600060672</h4>
    </div>
  );
};

export default About;